import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "environment";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

export interface ActiveAnnouncementApi {
  id: string;
  title: string;
  bannermessage: string;
  content: string;
  severityid: number;
  modifiedtime: string;
}

interface ApiResponse<T> {
  isSuccess: boolean;
  statusCode: number;
  status: string;
  data: T | null;
}

@Injectable({ providedIn: "root" })
export class AnnouncementClient {
  endpoint = "announcement";

  constructor(private httpClient: HttpClient) {}

  getActive(facilityId?: string | null): Observable<ActiveAnnouncementApi[]> {
    const params: Record<string, string> = facilityId ? { facilityId } : {};
    return this.httpClient
      .get<ApiResponse<ActiveAnnouncementApi[]>>(
        `${environment.endpoint}/${this.endpoint}/active`,
        { params }
      )
      .pipe(map((res) => res?.data ?? []));
  }
}
